import Axios from 'config/service.config'
import config from 'config/env_config'

export const getValidCoupon = async (params) => {
  try {
    const { data } = await Axios({
      baseURL: config.partner,
      url: '/scheduling-coupons/valid',
      withCredentials: true,
      params
    })
    return { success: true, data }
  } catch (error) {
    return { success: false, errors: error.response.data.errors }
  }
}
